import { render, staticRenderFns } from "./FormEdit.vue?vue&type=template&id=45a37d46&scoped=true"
import script from "./FormEdit.vue?vue&type=script&lang=js"
export * from "./FormEdit.vue?vue&type=script&lang=js"
import style0 from "./FormEdit.vue?vue&type=style&index=0&id=45a37d46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a37d46",
  null
  
)

export default component.exports